export const TOGO_CHANNEL_HEADER_VALUE = 'icatogo'